import landingPagePhoto from '../assets/Onboarding.png'
import { FooterWithSocialLinks } from './Footer';
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();

  const isAuthenticated = () => {
    const token = localStorage.getItem("authToken");
    return !!token; // returns true if token exists, false otherwise
  };
  const handleRequestAService = () => {
    navigate("/signup");
  }
    return (
        <div className="min-h-screen">
      {/* Hero Section */}
      <section className="container mx-auto py-20 px-4 flex">
    {/* Image on the left */}
    <div className="w-2/5 flex items-center">
        <img src={landingPagePhoto} alt="Healthcare Image" className="rounded-lg shadow-xl" />
    </div>

    {/* Content on the right */}
    <div className="w-3/5 pl-16 flex flex-col justify-center items-center text-center">
        <h1 className="text-6xl font-extrabold text-gray-800 mb-4 leading-snug">Revolutionizing Healthcare using web3</h1>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-lg text-center">Experience the next generation of healthcare with Web3 technologies. Dive into a world of security, transparency, and innovation.</p>
        
        {/* CTA Button with an icon */}
        <div class="flex space-x-4"> 
        <button className="flex items-center border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-lg hover:bg-blue-600 hover:text-white transition duration-300 transform hover:scale-105"
        onClick={handleRequestAService}>
            <span>Request a service</span>
    {/* <i className="material-icons ml-2">arrow_forward</i> This assumes you have Material Icons integrated */}
        </button>

    <button className="flex items-center bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-500 transition duration-300 transform hover:scale-105"
    onClick={() => {navigate("/providers-signup")}}>
        <span>Providers Dashboard</span>
        {/* <i className="material-icons ml-2">arrow_forward</i> This assumes you have Material Icons integrated */}
    </button>
</div>
    </div>
</section>
     

      {/* Features Section */}
      <section className="container mx-auto my-10">
        {/* ... Feature components ... */}
      </section>

      {/* Testimonials Section */}
      <section className="container mx-auto my-10">
        {/* ... Testimonial components ... */}
      </section>

      {/* Footer */}
      <FooterWithSocialLinks />
    </div>
    );
  }
  
  export default LandingPage;
  